<template>
    <!-- Image -- along with moderation section -->
    <div 
        v-if="( !image_moderation_result || image_moderation_result == 'pass' || force_show_image )"
    >
        <div
            style="text-align: center;"
        >
            <a :href="blob_src_url" target="_blank">
                <img
                    :src="blob_src_url"
                    style="max-height: 200px; max-width: 200px;"
                />
            </a>
        </div>
        <div
            v-if="image_caption"
            style="white-space: pre-wrap;"
            v-html="getWrappedContent()"
        >
        </div>
    </div>
    <div
        v-else
        class="image-moderation-container"
    >
        <!-- If image was flagged, simply show a black outline, unless the user decides to view -->
        <img
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            style="height: 200px; width: 200px; background-color: black;"
            v-on:click="promptToShowImage"
        >
        <div
            v-if="image_moderation_result == 'no-result'"
            class="image-moderation-text"
        >
            Scanning Content
            <v-btn
                color="primary darken-1"
                text
                @click="forceShowImage"
            >
                Skip Check
            </v-btn>
        </div>
        <div
            v-else-if="image_moderation_result == 'fail'"
            class="image-moderation-text"
        >
            Warning <v-icon style="padding: 0; color: white;" v-on:click="promptToShowImage">mdi-information</v-icon>
        </div>
    </div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            force_show_image: false,
        }
    },

    props: {
        image_moderation_result: {
            type: String,
            default: function() { return "pass"; }
        },
        blob_src_url: {
            type: String,
            default: function() { return ""; }
        },
        image_caption: {
            type: String,
            default: function() { return null; }
        },
        is_left: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        has(value)
        {
            if ( value == null ) return false;
            if ( typeof value === 'string' && value.trim().length == 0 ) return false;
            return true;
        },

        forceShowImage()
        {
            this.force_show_image = true;
        },

        promptToShowImage()
        {
            this.$rc.confirm(
                'Sensitive Content Warning',
                'This image was flagged for potential graphic content.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Show Anyway', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' ) return;
                    this.forceShowImage();
                },
            );
        },

        getWrappedContent()
        {
            let ret = this.image_caption;
            if ( ret == null ) return ret;

            ret = this.$rc.wrapHTML(ret,this.is_left); 

            if ( ret.toLowerCase().includes("?count_hits=false") )
            {
                this.has_shortened_links = true;
            }
            else
            {
                this.has_shortened_links = false;
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>